import * as ActionTypes from "./actionTypes";

export function loadIntegrations(appKey) {
	return { type: ActionTypes.LOAD_INTEGRATIONS, appKey };
}

export function loadIntegrationsSuccess(integrations) {
	return { type: ActionTypes.LOAD_INTEGRATIONS_SUCCESS, integrations };
}

export function loadIntegrationsFail(errorMessage) {
	return { type: ActionTypes.LOAD_INTEGRATIONS_FAIL, errorMessage };
}

export function createIntegration(integration, appId) {
	return { type: ActionTypes.CREATE_INTEGRATION, integration, appId };
}

export function createIntegrationSuccess(appId) {
	return { type: ActionTypes.CREATE_INTEGRATION_SUCCESS, appId };
}

export function createIntegrationFail(errorMessage) {
	return { type: ActionTypes.CREATE_INTEGRATION_FAIL, errorMessage };
}

export function selectIntegration(integration) {
	return { type: ActionTypes.SELECT_INTEGRATION, integration };
}

export function selectIntegrationSuccess(integration) {
	return { type: ActionTypes.SELECT_INTEGRATION_SUCCESS, integration };
}

export function resetCurrentIntegration() {
	return { type: ActionTypes.RESET_CURRENT_INTEGRATION };
}

export function selectIntegrationFailure(errorMessage) {
	return { type: ActionTypes.SELECT_INTEGRATION_FAILURE, errorMessage };
}

export function editIntegration(id, integration, appId) {
	return { type: ActionTypes.EDIT_INTEGRATION, id, integration, appId };
}

export function editIntegrationSuccess(appId) {
	return { type: ActionTypes.EDIT_INTEGRATION_SUCCESS, appId };
}

export function editIntegrationFailure(errorMessage) {
	return { type: ActionTypes.EDIT_INTEGRATION_FAILURE, errorMessage };
}

export function deleteIntegration(integration, appId) {
	return { type: ActionTypes.DELETE_INTEGRATION, integration, appId };
}

export function deleteIntegrationSuccess(appId) {
	return { type: ActionTypes.DELETE_INTEGRATION_SUCCESS, appId };
}

export function deleteIntegrationFailure(errorMessage) {
	return { type: ActionTypes.DELETE_INTEGRATION_FAILURE, errorMessage };
}
